import React from "react";
import { Link } from "react-router-dom";
import { useSpring, animated } from '@react-spring/web';
import { Container, Row, Col, Button, Form, InputGroup, Alert, Spinner } from "react-bootstrap";
import icon_check from '../images/icon_check.png';

const apiKey = process.env.REACT_APP_API_KEY;
const apiUrl = process.env.REACT_APP_API_PATH;


const NewsLetter = () => {
    const [email, setEmail] = React.useState('');
    const [loading, setLoading] = React.useState(false);
    const [error, setError] = React.useState('');
    const [gracias, setGracias] = React.useState(false);

    const animacion = useSpring({
        opacity: gracias ? 1 : 0,
        transform: gracias ? 'scale(1)' : 'scale(0.8)',
        config: { duration: 500 },
    });

    const handleSubmit = async (event) => {
        event.preventDefault();
        setLoading(true);
        setError('');
        try {
            if(!email) {
                setError('El correo es requerido');
                setLoading(false);
                return;
            }
            const custom_headers = new Headers();
            custom_headers.append('x-api-key', `${apiKey}`);
            custom_headers.append('Content-Type', 'application/json');
            
            const raw = JSON.stringify({
                "CORREO": email
            });

            const requestOptions = {
                method: 'POST',
                headers: custom_headers,
                body: raw,
                redirect: 'follow'
            };
            
            const response = await fetch(`${apiUrl}/api/suscriptores`, requestOptions);
            const result = await response.json();

            if(result.error) {
                setError(result.error);
                return;
            }

            setGracias(true);
            setEmail('');
            setTimeout(() => {
                setGracias(false);
            }, 3000);
            
        } catch (error) {
            setError(error.message);
        }
        setLoading(false);
    };
    
    return (
        <section id="newsletter" className="newsletter">
            <Container>
                <Row className="justify-content-center contenido">
                    <Col lg={6} className="mb-3 mt-5">
                        <h1 className="heading1 text-white">Newsletter</h1>
                    </Col>
                </Row>
                <Row className="justify-content-center contenido">
                    <Col lg={6} className="text-center mb-5">
                        {(gracias) ? (
                            <animated.div style={animacion}>
                                <Row className="justify-content-center">
                                    <Col lg={12} md={12} sm={12} xs={12} className="mb-3 mt-3 text-center">
                                        <img src={icon_check} alt="icon check" className="img img-fluid" width={100} />
                                        <br/><br/>
                                        <h1 className="heading1 text-white">¡Suscripción realizada con éxito!</h1>
                                    </Col>
                                </Row>
                            </animated.div>
                        ) : (
                            <Form className="form-newsletter">
                            <InputGroup className="mb-3">
                                <Form.Control size="lg"
                                    placeholder="correo@ejemplo.com"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    />
                                <Button className="newsletter-button" onClick={handleSubmit}>
                                    Suscribirme
                                </Button>
                            </InputGroup>
                            <p className="text-white">
                                Al suscribirte a nuestra newsletter, <Link to="/terminos" target="blank">aceptas los términos y condiciones de uso.</Link>
                            </p>
                            {error && (
                                <Alert variant="danger" dismissible onClose={() => setError('')}>{error}</Alert>
                            )}
                            
                            {loading && <Spinner animation="border" />}
                        </Form>
                        )}
                        
                    </Col>
                </Row>
            </Container>
        </section>
    );
};

export default NewsLetter;